<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="handleFilter"
        style="width: 200px; margin-right: 20px"
        class="filter-item"
        placeholder="要素名称"
        v-model="listQuery.elementName"
        size="small"
      >
      </el-input>

      <el-button
        style="width: 100px; margin-left: 30px"
        class="filter-item"
        type="primary"
        icon="search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
    </template>
    <el-button
      class="filter-item"
      v-permission:function="['regex:btn_add']"
      style="margin-left: 10px"
      @click="handleCreate"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      >添加</el-button
    >
    <el-table
      :key="tableKey"
      :data="list"
      v-loading.body="listLoading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%; margin-top: 20px"
    >

       <el-table-column type="expand">
      <template slot-scope="scope">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="要素名称">
            <span>{{ scope.row.elementName }}</span>
          </el-form-item>
          <el-form-item label="父正则">
            <span>{{ scope.row.parentId }}</span>
          </el-form-item>
          <el-form-item label="启用状态">
            <span v-if="scope.row.status === 0" style="color: green">启用</span>
            <span v-if="scope.row.status === 1" style="color: red">禁用</span>
          </el-form-item>
          <el-form-item label="启用状态">
            <span>{{ scope.row.shopId }}</span>
          </el-form-item>
          <el-form-item label="要素正则">
            <span>{{ scope.row.extractRegex }}</span>
          </el-form-item>
          <el-form-item label="替换文本正则">
            <span>{{ scope.row.replaceRegex }}</span>
          </el-form-item>
          <el-form-item label="替换的内容">
            <span>{{ scope.row.replaceValue }}</span>
          </el-form-item>

          <el-form-item label="起始位置字符">
            <span>{{ scope.row.matcherStartIndex }}</span>
          </el-form-item>

          <el-form-item label="结束位置字符">
            <span>{{ scope.row.matcherEndIndex }}</span>
          </el-form-item>

          <el-form-item label="创建时间">
            <span>{{ scope.row.createTime }}</span>
          </el-form-item>

          <el-form-item label="替换的内容">
            <span>{{ scope.row.replaceValue }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
      <el-table-column align="center" label="序号" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="210" align="center" label="要素名称">
        <template slot-scope="scope">
          <span>{{ scope.row.elementName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" align="center" label="父正则">
        <template slot-scope="scope">
          <span> {{ scope.row.parentId }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="启用状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" style="color: green">启用</span>
          <span v-if="scope.row.status === 1" style="color: red">禁用</span>
        </template>
      </el-table-column>
      <el-table-column width="310" align="center" label="要素正则">
        <template slot-scope="scope">
          <span>{{ scope.row.extractRegex }}</span>
        </template>
      </el-table-column>

      <el-table-column width="200" align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-permission:function="['regex:btn_edit']"
            size="small"
            type="success"
            @click="handleUpdate(scope.row)"
            >编辑
          </el-button>
          <el-button
            v-permission:function="['regex:btn_del']"
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-show="!listLoading" class="pagination-container"> -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </template>
    <!-- </div> -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="要素名称" prop="elementName">
          <el-input
            v-model="form.elementName"
            placeholder="请输入要素名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="父类正则">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="form.parentId"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            ></i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.elementName }}</div>
              <span class="addr">{{ item.extractRegex }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="要素正则" prop="extractRegex">
          <el-input
            v-model="form.extractRegex"
            placeholder="要素正则"
          ></el-input>
        </el-form-item>
        <el-form-item label="替换文本正则" prop="replaceRegex">
          <el-input
            v-model="form.replaceRegex"
            placeholder="替换文本正则"
          ></el-input>
        </el-form-item>
        <el-form-item label="替换的内容" prop="replaceValue">
          <el-input
            v-model="form.replaceValue"
            placeholder="替换的内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="起始位置字符" prop="matcherStartIndex">
          <el-input
            v-model="form.matcherStartIndex"
            placeholder="起始位置字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="包含启始字符" prop="isContainsStart">
          <el-radio v-model="form.isContainsStart" :label="1">是</el-radio>
          <el-radio v-model="form.isContainsStart" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="结束位置字符" prop="matcherEndIndex">
          <el-input
            v-model="form.matcherEndIndex"
            placeholder="结束位置字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="包含结束字符" prop="isContainsEnd">
          <el-radio v-model="form.isContainsEnd" :label="1">是</el-radio>
          <el-radio v-model="form.isContainsEnd" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="循环次数" prop="circulateNum">
          <el-input-number required v-model="form.circulateNum"  :min="1" :max="10" label="循环次数"></el-input-number>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select
            class="filter-item"
            v-model="form.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button
          v-if="dialogStatus == 'create'"
          type="primary"
          @click="create('form')"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="update('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </d2-container>
</template>

<style>

.my-autocomplete li{

    line-height : normal;
    padding : 7px;
  
}
.my-autocomplete .name{
    text-overflow: ellipsis;
    overflow: hidden;
}

.my-autocomplete .addr{
    font-size: 12px;
    color: #b4b4b4;
}

.my-autocomplete .highlighted  .addr{
    color: #ddd;
}
 .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 150px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 40%;
  }
</style>

<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj,
  initOptions,
  getAllReg
} from "@/api/sysTool/regex/index";
import { mapGetters } from "vuex";
export default {
  name: "regex",
  data() {
    return {
      form: {
        elementName: undefined,
        parentId: undefined,
        extractRegex: undefined,
        replaceRegex: undefined,
        replaceValue: undefined,
        matcherStartIndex: undefined,
        isContainsStart: undefined,
        matcherEndIndex: undefined,
        isContainsEnd: undefined,
        status: undefined,
        createTime: undefined,
        circulateNum:undefined
      },
      rules: {
        elementName: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        extractRegex: [
          {
            required: true,
            message: '请输入正则',
            trigger: 'blur'
          }
        ],
        circulateNum: [
          {
            required: true,
            message: '请输入循环次数',
            trigger: 'blur'
          }
        ]
      },
      list: null,
      all: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        elementName: undefined,
      },
      elementTypeOptions: [],
      statusOptions: [
        { label: "启用", value: 0 },
        { label: "禁用", value: 1 },
      ],
      dialogFormVisible: false,
      dialogStatus: "",
      regex_btn_edit: this.hasPermissions(["regex:btn_edit"]),
      regex_btn_del: false,
      regex_btn_add: false,
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
    };
  },
  created() {
    this.getList();
    this.getAll();
    this.initElementTypeOptions();
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    //搜索方法
    querySearch(queryString, cb) {
      var regs = this.all;
      var results = queryString ? regs.filter(this.createFilter(queryString)) : regs;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return ((restaurant.elementName).toLowerCase().indexOf((queryString +='').toLowerCase()) === 0);
      };
    
    },
    handleSelect(item) {
      this.form.parentId = item.id;
    },
    handleIconClick(ev) {
      console.log("handleIconClick");
      console.log("ev" + ev);
    },
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    getAll(){
      getAllReg().then(res => {
        this.all = res;
      })
    },
    initElementTypeOptions() {
      var that = this;
      initOptions().then((res) => {
        that.elementTypeOptions = res;
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      getObj(row.id).then((response) => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = "update";
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then(() => {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          addObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "更新成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    exChangeOption(id) {
      var jsonobj = eval(this.elementTypeOptions);
      for (var i in jsonobj) {
        if (id === jsonobj[i].value) {
          return jsonobj[i].label;
        }
      }
    },
    resetTemp() {
      this.form = {
        elementName: undefined,
        elementTypeId: undefined,
        extractRegex: undefined,
        replaceRegex: undefined,
        replaceValue: undefined,
        matcherStartIndex: undefined,
        isContainsStart: undefined,
        matcherEndIndex: undefined,
        isContainsEnd: undefined,
        status: undefined,
      };
    },
  },
};
</script>
